/**
 * Salons icon: barber shop.
 * Uses the provided barber shop icon image.
 */
export default function SalonsIcon({ size = 20, style = {} }) {
  return (
    <img
      src="/icons/salons-icon.png"
      alt=""
      width={size}
      height={size}
      style={{ display: 'block', flexShrink: 0, objectFit: 'contain', imageRendering: '-webkit-optimize-contrast', ...style }}
    />
  );
}
